import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselSchedulesComponent } from './vessel-schedules.component';



@NgModule({
  declarations: [VesselSchedulesComponent],
  imports: [
    CommonModule
  ]
})
export class VesselSchedulesModule { }
